import {
  FulfillmentLifecycleStatus,
  FulfillmentLineExceptionType,
  FulfillmentLineStatus,
  FulfillmentWaveStatus,
  FulfillmentWaveType,
  OrderType,
} from './types';

export const FULFILLMENT_PAGE_SIZE = 15;

export const LIFECYCLE_STATUSES: FulfillmentLifecycleStatus[] = [
  'pending',
  'picking',
  'picked',
  'packing',
  'packed',
  'lpu_staged',
  'shipped',
  'cancelled',
];

export const LINE_STATUSES: FulfillmentLineStatus[] = [
  'pending',
  'quality-check',
  'picked',
  'packed',
  'exception',
];

export const EXCEPTION_TYPES: { value: FulfillmentLineExceptionType; label: string }[] = [
  { value: 'item_not_found', label: 'Item not found' },
  { value: 'item_damaged', label: 'Item damaged' },
  { value: 'skip', label: 'Skip' },
  { value: 'other', label: 'Other' },
];

export const ORDER_TYPE_LABELS: Record<OrderType, string> = {
  bike_only: 'Bike only',
  paa_only: 'PA&A only',
  mixed: 'Mixed',
  unknown: '—',
};

export const LIFECYCLE_STATUS_LABELS: Record<FulfillmentLifecycleStatus, string> = {
  pending: 'Pending',
  picking: 'Picking',
  picked: 'Picked',
  packing: 'Packing',
  packed: 'Packed',
  lpu_staged: 'LPU Staged',
  shipped: 'Shipped',
  cancelled: 'Cancelled',
};

export const WAVE_STATUS_LABELS: Record<FulfillmentWaveStatus, string> = {
  open: 'Open',
  in_progress: 'In Progress',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

export const WAVE_TYPE_LABELS: Record<FulfillmentWaveType, string> = {
  bike_only: 'Bikes Only',
  paa_only: 'PA&A Only',
  mixed: 'Mixed',
};

export const WAVE_STATUS_COLORS: Record<FulfillmentWaveStatus, { bg: string; color: string }> = {
  open: { bg: '#f5f5f5', color: '#757575' },
  in_progress: { bg: '#c9e1f2', color: '#0163b0' },
  completed: { bg: '#e7fbf1', color: '#009320' },
  cancelled: { bg: '#e0e0e0', color: '#757575' },
};

export const WAVE_ORDER_STATUS_LABELS: Record<string, string> = {
  pending: 'Pending',
  picking: 'Picking',
  picked: 'Picked',
  cancelled: 'Cancelled',
};

export const LIFECYCLE_STATUS_COLORS: Record<
  FulfillmentLifecycleStatus,
  { bg: string; color: string }
> = {
  pending: { bg: '#eeeeee', color: '#616161' },
  picking: { bg: '#c9e1f2', color: '#0163b0' },
  picked: { bg: '#e7fbf1', color: '#009320' },
  packing: { bg: '#ffedd5', color: '#c2410c' },
  packed: { bg: '#00c160', color: '#ffffff' },
  lpu_staged: { bg: '#fef3c7', color: '#92400e' },
  shipped: { bg: '#01741e', color: '#ffffff' },
  cancelled: { bg: '#e0e0e0', color: '#757575' },
};
